var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.html
    ? _c(
        "Modal",
        {
          ref: "modal",
          attrs: {
            "overlay-type": _vm.modalName,
            "html-classes": ["hide--header", "show--modal"],
            "initial-visible": _vm.initialVisible,
            light: _vm.light,
            "full-height": _vm.fullHeight
          }
        },
        [
          _c("div", {
            staticClass: "overlay-dialog__content",
            domProps: { innerHTML: _vm._s(_vm.html) }
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }